import React from 'react';
import _ from 'lodash';
import { Grid, IconButton, FormControlLabel, Checkbox } from '@mui/material';

import { IconNames } from 'ui/theme';
import { Autocomplete } from 'ui/components/Autocomplete/Autocomplete';
import { Icon } from 'ui/components/Icon';
import { TextField } from 'ui/components/TextField/TextField';

import { ContactType } from 'services/addresses';

import { AddressContactListItemProps } from './types';

export const AddressContactListItem: React.FC<AddressContactListItemProps> = ({
  errors,
  contact,
  onEdit,
  onDelete,
  onCheckboxClick,
}) => {
  const handleTextfieldChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onEdit({ ...contact, [event.target.name]: event.target.value || null });
  };

  const handleTypeChange = (e: any, value: ContactType | null) => {
    onEdit({ ...contact, type: value });
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={4}>
        <TextField
          label="Name"
          name="name"
          type="text"
          placeholder="Enter name"
          autoComplete="nope"
          required
          value={contact.name}
          onChange={handleTextfieldChange}
          error={!!errors.name}
          helperText={errors.name}
          dataQa="address-contact-name"
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label="Value"
          name="value"
          type="text"
          placeholder="Enter value"
          autoComplete="nope"
          required
          value={contact.value}
          onChange={handleTextfieldChange}
          error={!!errors.value}
          helperText={errors.value}
          dataQa="address-contact-value"
        />
      </Grid>
      <Grid item xs={2}>
        <Autocomplete
          label="Type"
          placeholder="Select type"
          options={_.values(ContactType)}
          getOptionLabel={(id: any) => id}
          value={contact.type}
          onChange={handleTypeChange}
          required
          error={!!errors.type}
          helperText={errors.type}
          dataQa="address-contact-type"
        />
      </Grid>
      <Grid item xs={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={contact.defaultFlag!}
              value="default"
              inputProps={
                {
                  'data-qa': 'address-contact-default',
                } as any
              }
            />
          }
          label="Default"
          onChange={onCheckboxClick}
        />
      </Grid>

      <Grid item xs={1}>
        <IconButton onClick={onDelete} size="large">
          <Icon name={IconNames.Delete} />
        </IconButton>
      </Grid>
    </Grid>
  );
};
